module.exports = __webpack_public_path__ + "img/keyboard.06a9cfb6.svg";